(function () {
  function getMoneyFormat() {
    if (window.theme && window.theme.settings && window.theme.settings.moneyFormat) {
      return window.theme.settings.moneyFormat;
    }
    if (window.theme && window.theme.moneyFormat) {
      return window.theme.moneyFormat;
    }
    return '${{amount}}';
  }

  function formatMoneyFromCents(cents) {
    if (typeof window.theme !== 'undefined' && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      try {
        return window.theme.Currency.formatMoney(cents, getMoneyFormat());
      } catch (e) {
        /* fall through */
      }
    }
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      try {
        return Shopify.formatMoney(cents, getMoneyFormat());
      } catch (e) {
        /* fall through */
      }
    }
    var n = Number(cents) / 100;
    if (Number.isNaN(n)) return '';
    return n.toFixed(2);
  }

  function initBuybox(root) {
    var formId = root.getAttribute('data-product-form');
    if (!formId) return;
    var form = document.getElementById(formId);
    if (!form) return;

    var variantSelect = form.querySelector('select[name="id"]');
    var sellingInput = form.querySelector('input[name="selling_plan"]');
    var plans = root.querySelectorAll('[data-rho-sp-plan]');
    var previewPlan = root.querySelector('[data-rho-sp-plan-preview]');
    var otpBtn = form.querySelector('.rho-sp-buybox__otp-btn');
    var otpTargetId = root.getAttribute('data-otp-price-target');

    function getOtpPriceEl() {
      if (otpTargetId) {
        var byId = document.getElementById(otpTargetId);
        if (byId) return byId;
      }
      return form.querySelector('.rho-sp-buybox__otp-price');
    }

    function deactivatePreview() {
      if (!previewPlan) return;
      previewPlan.classList.remove('rho-sp-buybox__plan--active');
      previewPlan.setAttribute('aria-checked', 'false');
    }

    function setActive(planBtn) {
      plans.forEach(function (p) {
        p.classList.remove('rho-sp-buybox__plan--active');
        p.setAttribute('aria-checked', 'false');
      });
      deactivatePreview();
      planBtn.classList.add('rho-sp-buybox__plan--active');
      planBtn.setAttribute('aria-checked', 'true');

      var vid = planBtn.getAttribute('data-variant-id');
      var spid = planBtn.getAttribute('data-selling-plan-id') || '';

      if (variantSelect && vid) {
        variantSelect.value = vid;
        variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (sellingInput) {
        sellingInput.value = spid;
      }

      var months = planBtn.getAttribute('data-months');
      var otpEl = getOtpPriceEl();
      var otpPriceNode = otpTargetId ? document.getElementById(otpTargetId) : null;
      var shipEl = form.querySelector('.rho-sp-buybox__otp-shipping');
      if (
        !shipEl &&
        otpPriceNode &&
        otpPriceNode.nextElementSibling &&
        otpPriceNode.nextElementSibling.classList &&
        otpPriceNode.nextElementSibling.classList.contains('rho-sp-buybox__otp-shipping')
      ) {
        shipEl = otpPriceNode.nextElementSibling;
      }
      if (otpEl) {
        var overrideCents = planBtn.getAttribute('data-otp-override-cents');
        var overrideN = overrideCents != null && overrideCents !== '' ? Number(overrideCents) : NaN;
        var cents = planBtn.getAttribute('data-otp-cents');
        var money = planBtn.getAttribute('data-otp-money');
        var moneyTrim = money && String(money).trim();
        var n = cents != null && cents !== '' ? Number(cents) : NaN;
        var piece = '';
        if (!Number.isNaN(overrideN) && overrideN > 0) {
          piece = formatMoneyFromCents(overrideCents);
        } else if (moneyTrim) {
          piece = moneyTrim;
        } else if (!Number.isNaN(n)) {
          piece = formatMoneyFromCents(cents);
        }
        otpEl.textContent = piece ? ' ' + piece : '';
      }
      if (shipEl) {
        // 6-month tier: no paid shipping line (card already says free shipping)
        var hideShipping =
          planBtn.getAttribute('data-otp-free-shipping') === 'true' || months === '6';
        shipEl.hidden = hideShipping;
        shipEl.classList.toggle('rho-sp-buybox__otp-shipping--hidden', hideShipping);
        shipEl.setAttribute('aria-hidden', hideShipping ? 'true' : 'false');
      }
    }

    plans.forEach(function (btn) {
      btn.addEventListener('click', function () {
        setActive(btn);
      });
    });

    if (previewPlan) {
      previewPlan.addEventListener('click', function () {
        plans.forEach(function (p) {
          p.classList.remove('rho-sp-buybox__plan--active');
          p.setAttribute('aria-checked', 'false');
        });
        previewPlan.classList.add('rho-sp-buybox__plan--active');
        previewPlan.setAttribute('aria-checked', 'true');
      });
    }

    var initial = root.querySelector('.rho-sp-buybox__plan--active');
    if (initial) {
      setActive(initial);
    } else {
      var threeMo = root.querySelector('[data-rho-sp-plan][data-months="3"]');
      if (threeMo) {
        setActive(threeMo);
      } else if (plans.length) {
        setActive(plans[0]);
      }
    }

    if (otpBtn && sellingInput && variantSelect) {
      otpBtn.addEventListener('click', function () {
        var active = root.querySelector('[data-rho-sp-plan].rho-sp-buybox__plan--active') || plans[0];
        if (!active) return;
        sellingInput.value = '';
        var vid = active.getAttribute('data-variant-id');
        if (vid) {
          variantSelect.value = vid;
          variantSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
        form.requestSubmit();
      });
    }
  }

  function boot() {
    document.querySelectorAll('.rho-sp-buybox').forEach(initBuybox);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
